<template>
  <div class="w-full flex flex-col md:flex-row">
    <!-- Shipping header -->
    <div class="h-full w-full md:w-1/3 mb-4">
      <vx-card class="mb-4">
        <h1>{{ $t('pages.shop.checkout.tab2.headerTitle') }}</h1>
        <vs-divider />

        <div class="w-full flex flex-col space-y-1">
          <vs-radio v-for="(item, index) in shipmentTypeOptions" :value="choosedShipmentOptionIndex" vs-name="chooseShipping" :key="index" :vs-value="index"
                    @input="setShipmentType(index)" class="mr-4 p-1" :class="{'bg-success-100 shadow-2xl rounded-lg': choosedShipmentOptionIndex === index}">
            <div class="w-full flex flex-col" @click="setShipmentType(index)">
              <span class="text-sm">{{ $t(`pages.shop.checkout.tab2.shipment.${index}`) }}</span>
              <span> {{ $t('pages.shop.checkout.tab2.price') }} {{ item.fee | BRL }} </span>
              <span> {{ $t('pages.shop.checkout.tab2.days') }} {{ item.days }} </span>
            </div>
          </vs-radio>
        </div>

        <vs-divider />
        <div class="w-full flex justify-between">
          <span class="font-bold text-primary"> {{ $t('pages.shop.total') }} </span>
          <span class="font-bold text-primary text-center" v-if="$store.state.Profile.isBRL()"> {{ $store.getters['Shop/getShipmentFee'] | BRL }} </span>
          <span class="font-bold text-primary text-center" v-else-if="$store.state.Profile.isUSD()"> {{ $store.getters['Shop/getShipmentFee'] | USD }} </span>
        </div>

        <vs-divider />

        <vs-button class="w-full" @click="$emit('next-tab')" :disabled="disableShipmentButton">
          {{ $t('pages.shop.checkout.tab1.placeOrder') | uppercase }}
        </vs-button>
      </vx-card>
    </div>

    <div class="w-full md:w-2/3 pl-2 h-full">
      <!-- Select Address -->
      <div class="w-full flex flex-col justify-start">
        <!-- LEFT COL: CONTINUE WITH SAVED ADDRESS -->
        <div v-for="(address, index) in addressOptions" :key="index" @click="setShipmentAddress(index)"
             class="w-full mb-4 p-2" :class="{'bg-success-100 shadow-2xl rounded-lg': choosedShipmentAddressIndex === index,
                                              'bg-white shadow rounded-lg': choosedShipmentAddressIndex !== index}">

          <vs-radio :value="choosedShipmentAddressIndex" :vs-value="index" class="mr-4" vs-name="chooseAddress">
            <span class="text-xl">{{ $t('pages.shop.checkout.tab2.titleMyAddress') }}</span>
          </vs-radio>

          <div class="w-full flex flex-col" v-if="address.isDataAddressValid() && index !== lastAddressElement">
            <bds-label :text="$t('pages.users.address.zipcode')"/>
            <span>{{ address.zipCode }}</span>
            <bds-label :text="$t('pages.users.address.country')"/>
            <span>{{ address.country }} - {{ address.state }} - {{ address.city }}</span>
            <span>{{ address.address }} - {{ address.complement }}</span>
          </div>

          <user-address v-else :value="address" class="w-full" @input="customAddressChanged"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserAddress from "@/views/profileSettings/UserAddress";
import {DataAddress} from "@/models/User.model";

import {showErrorNotify} from "@/helpers/functionsHelpers";
import ShopService from "@/services/Shop.service";

import {
  Shipping,
  SHIPPING_ADDRESS_PROFILE,
  SHIPPING_TYPE_SEDEX,
  ShippingOptions
} from "@/models/shipping.model";

export default {
  name: "AddressSelectWizard",
  components: {
    UserAddress
  },
  props: {
    bind2Doctor: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      customAddress: null,

      addressOptions: [],
      shipmentOptions: [],

      //

    }
  },
  watch: {

  },
  computed: {
    lastAddressElement() {
      return (this.addressOptions.length -1);
    },
    shipmentTypeOptions() {
      return this.shipmentOptions;
    },

    choosedShipmentOptionIndex() {
      return this.$store.getters['Shop/getShipmentOptionIndex'];
    },
    choosedShipmentAddressIndex() {
      return this.$store.getters['Shop/getShipmentAddressIndex'];
    },
    disableShipmentButton() {
      return !this.$store.getters['Shop/isShipmentAddressValid'];
    }
  },
  methods: {
    setShipmentType(shipmentOptionIndex) {
      let choosed_shipment = new Shipping();
      choosed_shipment.shipmentType = shipmentOptionIndex;
      choosed_shipment.shipmentOption = this.shipmentOptions[shipmentOptionIndex];
      this.$store.dispatch('Shop/setShipmentOption', choosed_shipment);
    },
    setShipmentAddress(addressIndex) {
//      let old_address_index = this.choosedShipmentAddressIndex;
      let choosed_address = new Shipping();
      choosed_address.addressType = addressIndex;
      choosed_address.address = DataAddress.FromObj(this.addressOptions[addressIndex]);

      return this.$store.dispatch('Shop/setShipmentAddress', choosed_address).then(() => {
        if (!choosed_address.address.isDataAddressValid()) {
          return Promise.resolve(false);
        }

        // if (choosed_address.address.isDataAddressValid() && old_address_index === addressIndex) {
        //   return Promise.resolve(false);
        // }

        this.$vs.loading();
        this.fetchShippingOptions(choosed_address.address.zipCode).then(() => {
          choosed_address.shipmentType = SHIPPING_TYPE_SEDEX;
          choosed_address.setShipment(this.shipmentOptions[SHIPPING_TYPE_SEDEX]);
          return this.$store.dispatch('Shop/setShipment', choosed_address);
        }).then(() => {
          this.$vs.loading.close();
          return Promise.resolve(true);
        }).catch((error) => {
          console.error('ERROR ', error);
          return Promise.reject(error);
        });
      });
    },
    fetchShippingAddress() {
      const payload = {
        queryAddress: [this.bind2Doctor]
      }

      return ShopService.fetchAddress(payload).then((response) => {
        this.addressOptions = [];
        for (let address of response) {
          this.addressOptions.push(DataAddress.FromObj(address));
        }
        this.addressOptions.push(new DataAddress());
        return Promise.resolve(true);
      }, (error) => {
        showErrorNotify(this, error);
        return Promise.reject();
      });
    },
    fetchShippingOptions(zip_code) {
      return ShopService.queryShippingPrice(zip_code).then((response) => {
        this.shipmentOptions = [];
        for (let option of response) {
          this.shipmentOptions.push(ShippingOptions.FromObj(option));
        }
        return Promise.resolve(response);
      }, (error) => {
        this.$vs.loading.close();
        showErrorNotify(this, error);
        return Promise.reject();
      });
    },

    customAddressChanged(newAddress) {
      this.addressOptions[this.lastAddressElement] = DataAddress.FromObj(newAddress);
      return this.setShipmentAddress(this.lastAddressElement);
    }
  },
  mounted() {
    if (this.$store.getters['Shop/hasShippingInCart']) {
      this.fetchShippingAddress().then(() => {
        return this.setShipmentAddress(SHIPPING_ADDRESS_PROFILE);
      });
    }
  }
}
</script>

<style scoped>

</style>
